import api from './api';

/**
 * Service for managing project-scoped tags
 */
export const tagsService = {
  /**
   * Get all tags for a project
   * @param {string} projectId - Project ID
   * @param {Object} params - Query parameters (page, limit, search)
   * @returns {Promise<Object>} API response
   */
  getTags: async (projectId, params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const response = await api.get(
      `/projects/${projectId}/tags${queryParams ? `?${queryParams}` : ''}`
    );
    return response.data;
  },

  /**
   * Search tags for typeahead
   * @param {string} projectId - Project ID
   * @param {string} query - Search term
   * @returns {Promise<Array>} List of tags
   */
  searchTags: async (projectId, query, params = {}) => {
    const queryParams = new URLSearchParams({ q: query, ...params }).toString();
    const response = await api.get(
      `/projects/${projectId}/tags/search?${queryParams}`
    );
    return response.data;
  },

  /**
   * Create a new tag
   * @param {string} projectId - Project ID
   * @param {Object} tagData - Tag name and optional color
   * @returns {Promise<Object>} Created tag
   */
  createTag: async (projectId, tagData) => {
    const response = await api.post(`/projects/${projectId}/tags`, tagData);
    return response.data;
  },

  /**
   * Update an existing tag
   * @param {string} projectId - Project ID
   * @param {string} tagId - Tag ID
   * @param {Object} tagData - Updated tag data
   * @returns {Promise<Object>} Updated tag
   */
  updateTag: async (projectId, tagId, tagData) => {
    const response = await api.put(
      `/projects/${projectId}/tags/${tagId}`,
      tagData
    );
    return response.data;
  },

  /**
   * Delete a tag
   * @param {string} projectId - Project ID
   * @param {string} tagId - Tag ID
   * @returns {Promise<Object>} API response
   */
  deleteTag: async (projectId, tagId) => {
    const response = await api.delete(`/projects/${projectId}/tags/${tagId}`);
    return response.data;
  },
};
